import request from "@/utils/request";
import qs from "qs";

/**船公司联想控件数据源**/
export function queryCarrierInfo(data) {
  return request({
    url: '/web/cts-web/auto-api/CTS_ILPCsCust/query/web/CTS_WEB_es',
    method: 'post',
    data
  });
}

/**发票类型联想控件数据源**/
export function queryInvoiceType(data) {
  return request({
    url: '/common/cts-manager/auto-api/CTS_ILPMdInvoiceType/query/common/CTS_ILP_es',
    method: 'post',
    data
  });
}

/**船名联想控件数据源**/
export function queryVesselInfo(data) {
  return request({
    url: '/common/cts-manager/auto-api/CTS_ILPMdVessel/query/common/CTS_ILP_es',
    method: 'post',
    data
  });
}

/**装、卸货港联想控件数据源**/
export function queryPoInfo(data) {
  return request({
    url: '/common/cts-manager/auto-api/CTS_ILPMdPort/query/common/CTS_ILP_es',
    method: 'post',
    data
  });
}

/**航次联想控件数据源**/
export function queryVoyageInfo(data) {
  return request({
    url: '/common/cts-manager/auto-api/CTS_ILPMdVoyagePlan/query/common/CTS_ILP_es',
    method: 'post',
    data
  });
}

/**包装联想控件数据源**/
export function queryPackageInfo(data) {
  return request({
    url: '/common/cts-manager/auto-api/CTS_ILPMdChargeunit/query/common/CTS_ILP_es',
    method: 'post',
    data
  });
}

/**箱公司联想控件数据源**/
export function queryCtnCompanyInfo(data) {
  return request({
    url: '/web/cts-web/auto-api/CTS_ILPCsCust/query/web/CTS_WEB_es',
    method: 'post',
    data
  });
}

/*
*业务要素联想控件数据源
*/
export function querybizTypeName(data) {
  return request({
    url: '/common/cts-manager/auto-api/CTS_ILPMdFacility/query/common/CTS_ILP_es',
    method: 'post',
    data
  });
}

/**箱型尺寸联想控件数据源**/
export function queryCtnSizeInfo(data) {
  return request({
    url: '/common/cts-manager/auto-api/CTS_ILPMdContainerType/query/common/CTS_ILP_es',
    method: 'post',
    data
  });
}

/**结算公司联想控件数据源**/
export function querySysCorpInfo(data) {
  return request({
    url: '/common/cts-manager/auto-api/CTS_ILPSysCorp/query/common/CTS_ILP_es',
    method: 'post',
    data
  });
}

/**用户联想控件数据源**/
export function querySysUserInfo(data) {
  return request({
    url: '/common/cts-manager/auto-api/CTS_ILPSysUser/query/common/CTS_ILP_es',
    method: 'post',
    data
  });
}

/**国家地区联想控件数据源**/
export function queryCountryInfo(data) {
  return request({
    url: '/common/cts-manager/auto-api/CTS_ILPMdCountry/query/common/CTS_ILP_es',
    method: 'post',
    data
  });
}

/**收发通发货人联想控件**/
export function queryShipperCneeNotifyShipperInfo(data) {
  return request({
    url: '/common/cts-manager/auto-api/CTS_ILPMdShipperCneeNotify/query/common/CTS_ILP_es',
    method: 'post',
    data
  });
}

/**状态数据字典**/
export function queryDictRows(params) {
  return request({
    url: '/common/dictionary/queryDictRows',
    method: 'get',
    params: {
      params
    }
  });
}
/**状态数据字典 获取英文显示值**/
export function queryDictionaryByCodeType(data) {
  return request({
    url: '/web/dictionary/queryDictionaryByCodeType',
    method: 'post',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
}

/**企业代码类型联想控件查询**/
export function queryCountry(params) {
  return request({
    url: '/web/lenovoControl/queryCountry',
    method: 'post',
    data: params
  });
}
/**收发通发货人联想控件**/
export function queryMdShipperCneeNotify(params) {
  return request({
    url: '/web/lenovoControl/queryMdShipperCneeNotify',
    method: 'post',
    data: params
  });
}

/**客服联想控件**/
export function querySales(params) {
  return request({
    url: '/web/lenovoControl/querySales',
    method: 'post',
    data: params
  });
}

/**客服联想控件**/
export function querySysUser(params) {
  return request({
    url: '/web/lenovoControl/querySysUser',
    method: 'post',
    data: params
  });
}

export function queryChangeLogs(data) {
  return request({
    url: '/web/changeLogs/queryElasticSearch?gridKey=042cbb6e14694bfd9db84060cc0786bb_HT',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
}

/**客服联想控件**/
export function getSecondRole(params) {
  return request({
    url: '/web/sysRole/getSecondRole',
    method: 'post',
    data: params
  });
}

export function queryCsCustInfo(data) {
  return request({
    url: '/common/cts-manager/auto-api/CTS_ILPCsCust/query/common/CTS_ILP_es',
    method: 'post',
    data
  });
}


export function queryGoCtnInfo(data) {
  return request({
    url: '/order/cts-manager/auto-api/GoCtn/query/order/DS_cts-manager_GoCtn_query',
    method: 'post',
    data
  });
}
export function queryMdReportTemplate (data) {
  return request({
    url: `/common/cts-manager/custom-api/CTS_ILP_MdReportTemplate/common/CTS_ILP_MdReportTemplate`,
    method: 'post',
    data
  });
}

export function queryVwCsCustInfo(data) {
  return request({
    url: '/common/cts-manager/auto-api/CTS_ILPVwCsCust/query/common/CTS_ILP_es',
    method: 'post',
    data
  });
}
